const config = {
  BOATER_SUPPORT_MAIL: "boater-support@pickapier.com",
  MARINA_SUPPORT_MAIL: "marina-support@pickapier.com",
  MAX_RESERVATION_VESSEL_LOA:   250,
  MAX_RESERVATION_VESSEL_BEAM:  40,
  MAX_RESERVATION_VESSEL_DRAFT: 20,
  MAX_REQUESTS: 1000,
  TE8_INTERVAL: 30,
  TE18_INTERVAL: 15,
  TE21_INTERVAL: 30,
  TE22_INTERVAL: 30,
  SUPPORTED_LANGS: ["en", "el", "de", "it", "fr", "es"],
  INCOMPLETE_POPEYE_STATUSES: ["NONE", "INVITED", "ON_WAITING_LIST"],
  VIEWABLE_PROFILE_FIELDS: [
    "first_name",
    "last_name",
    "email",
    "phone",
    "language",
    "date_of_birth",
    "country_of_residence",
    "nationality",
    "is_guest",
    "address",
    "postal_code",
    "auto_absence_report",
    "last_email_verification_sent"
  ],
  EDITABLE_PROFILE_FIELDS: [
    "first_name",
    "last_name",
    // 'email',
    "phone",
    "language",
    "date_of_birth",
    "country_of_residence",
    "nationality",
    "address",
    "postal_code",
    "auto_absence_report"
  ],
  EDITABLE_VESSEL_FIELDS: [
    "type",
    "length",
    "beam",
    "draft",
    "name",
    "water_electricity"
  ],
  VIEWABLE_VESSEL_FIELDS: [
    "type",
    "length",
    "beam",
    "draft",
    "name",
    "home_marina_id",
    "home_marina_name",
    "home_marina_verified",
    "home_marina_verified_at",
    "water_electricity"
  ],
  ADMIN_RESERVATION_FIELDS: [
    "id",
    "view_id",
    "boater_id",
    "vessel_id",
    "marina_id",
    "is_guest",
    "is_handled_by_support",
    "instant_book",
    "start_date",
    "end_date",
    "source",
    "created_at",
    "updated_at",
    "payment_accepted_online",
    "selected_match_id"
  ],
  ADMIN_VESSEL_FIELDS: [
    "id",
    "name",
    "type",
    "length",
    "beam",
    "draft",
    "water_electricity",
    "home_marina_name",
    "home_marina_id",
    "home_marina_verified_at",
    "home_marina_verified"
  ],
  ADMIN_RESERVATION_STATUS_FIELDS: [
    "id",
    "status_code",
    "action_required",
    "created_at",
    "updated_at"
  ],
  RESERVATION_SOURCES: ["MARINA", "BOATER"],
  VESSEL_TYPES: ["MOTOR", "SAIL", "WIDEBEAM", "BARGE", "NARROWBOAT", "RIB"],
  VESSEL_HULL_TYPES: ["MULTIHULL", "MONOHULL"],
  PAYMENT_METHODS: ["CREDIT_CARD", "IN_MARINA"],
  TRANSACTION_STATUSES: ["INITIATED", "PENDING", "VERIFIED"],
  RESERVATION_STATUS_CODES: [
    "INITIATED",
    "UPDATED",
    "APPROVED",
    "PAYED",
    "CANCELED_BY_BOATER",
    "CANCELED_BY_MARINA",
    "BOATER_ACCEPTED",
    "BOATER_ADDED_DOCUMENTS",
    "BOATER_DECLINED",
    "ON_HOLD",
    "INSTANT_BOOK",
    "EXPIRED_NO_MARINA_RESPONSE",
    "EXPIRED_NO_BOATER_RESPONSE",
    "INITIATED_WITH_PRICING_PLAN",
    "WAITING_LIST"
  ],
  RESERVATION_ACTION_ENTITIES: ["BOATER", "MARINA", "SUPPORT", "FINISHED"],
  ALLOWED_MARINA_RESERVATION_UPDATE_METHODS: ["UPDATE", "APPROVE", "CANCEL"],
  ALLOWED_BOATER_RESERVATION_UPDATE_METHODS: ["ACCEPT", "CANCEL", "UPDATE"],
  ATTACHMENT_TYPES: [
    "GENERIC",
    "RESERVATION_MARINA_ATTACHMENT",
    "RESERVATION_BOATER_ATTACHMENT",
    "SKIPPER_PASSPORT",
    "VESSEL_INSURANCE",
    "VESSEL_LICENSE",
    "SKIPPER_ID_LICENSE"
  ],
  BOATER_ATTACHMENTS: ["SKIPPER_PASSPORT", "SKIPPER_ID_LICENSE"],
  VESSEL_ATTACHMENTS: ["VESSEL_INSURANCE", "VESSEL_LICENSE"],
  MESSAGE_SOURCES: ["MARINA", "BOATER", "SUPPORT"],
  NOTIFICATION_TYPES: [
    "INFO",
    "REMOVED",
    "INITIATED",
    "UPDATED",
    "ACCEPTED",
    "DECLINED",
    "CANCELED",
    "APPROVED",
    "INSTANT_BOOK"
  ],
  NOTIFICATION_SUBJECTS: [
    "RESERVATION",
    "MEMBERSHIP",
    "MESSAGE",
    "HOME_MARINA_VERIFICATION",
    "ABSENCE_REPORT",
    "REMOVE_PARTNER"
  ],
  NOTIFICATION_OWNERS: ["MARINA", "BOATER"],
  MEMBERSHIP_TYPES: ["TEM"],
  MEMBERSHIP_REQUEST_STATUSES: ["PENDING", "APPROVED", "DECLINED"],
  MEMBERSHIP_REQUEST_ACTIONS: ["APPROVE", "DECLINE"],
  MARINA_REQUEST_TYPES: ["MEMBERSHIP", "HOME_MARINA_VERIFICATION"],
  MARINA_REQUEST_STATUSES: ["PENDING", "APPROVED", "DECLINED", "CANCELED"],
  MARINA_REQUEST_ACTIONS: ["APPROVE", "DECLINE", "CANCEL"],
  MARINA_REQUEST_SOURCES: ["DIRECT", "ABSENCE_REPORT"],
  ALLOWED_MARINA_PERMISSIONS: [
    "chat",
    "reservation",
    "request_membership",
    "absence_report"
  ],
  ALLOWED_ADDITIONAL_CHARGES: ["harbor_dues", "fees", "taxes"],
  WALLET_STATUSES: ["PENDING", "VERIFIED"],
  ALLOWED_CURRENCIES: ["EUR", "ILS"],
  MANGOPAY_KYC_LEVELS: ["LIGHT", "REGULAR"],
  MANGOPAY_USER_TYPES: ["NATURAL", "LEGAL"],
  TEM_VERIFICATION_FIELDS: ["email", "card_number", "home_marina_id", "phone"],
  ABSENCE_REPORT_REASONS: [
    "INTERNATIONAL_VACATION",
    "DOMESTIC_VACATION",
    "MAINTENANCE",
    "OTHER"
  ],
  ABSENCE_REPORT_SOURCES: ["BOATER", "MARINA", "SUPPORT"],
  ABSENCE_REPORT_STATUS_CODES: [
    "INITIATED",
    "EDITED_BY_BOATER",
    "EDITED_BY_MARINA",
    "APPROVED",
    "DELETED"
  ],
  MARINAS_LIST: [
    "Orikum Marina | Albania",
    "Orikum | Albania",
    "Vlore | Albania",
    "Sydney | New South Wales | Australia",
    "Empire Marina | New South Wales | Australia",
    "Berowra Waters | New South Wales | Australia",
    "New South Wales | Berowra Waters | New South Wales | Australia",
    "Woolwich Marina | New South Wales | Australia",
    "Darling Harbour Marina | New South Wales | Australia",
    "River Quays Marina | New South Wales | Australia",
    "The Spit at Mosman | New South Wales | Australia",
    "Nelson Bay | New South Wales | Australia",
    "New South Wales | Nelson Bay | New South Wales | Australia",
    "Gloucester | New South Wales | Australia",
    "New South Wales | Glouscester Marina Weaver | New South Wales | Australia",
    "South East Queensland | Queensland | Australia",
    "Gold Coast City Marina | Queensland | Australia",
    "Hope Harbour Marina | Queensland | Australia",
    "Horizon Shores Marina | Queensland | Australia",
    "Scarborough Marina | Queensland | Australia",
    "Dockside Marina | Queensland | Australia",
    "Kangaroo Point | Queensland | Australia",
    "Queensland | Kangaroo Point | Queensland | Australia",
    "Newport Waterways Marina | Queensland | Australia",
    "Moreton Bay | Queensland | Australia",
    "Waterfront Place Marina | Queensland | Australia",
    "Eagle Street Pier | Queensland | Australia",
    "East Coast Marina | Queensland | Australia",
    "Manly | Queensland | Australia",
    "Queensland | Manly | Queensland | Australia",
    "Raby Bay|Raby Bay Marina | Queensland | Australia",
    "Sunshine Coast | Queensland | Australia",
    "Queensland | Sunshine Coast | Queensland | Australia",
    "Kawana Waters Marina | Queensland | Australia",
    "Central Queensland | Queensland | Australia",
    "Gladstone Marina | Queensland | Australia",
    "Hervey Bay Marina | Queensland | Australia",
    "Rosslyn Bay Marina | Queensland | Australia",
    "Whitsundays | Queensland | Australia",
    "Hayman Island Marina | Queensland | Australia",
    "Abel Point Marina | Queensland | Australia",
    "The Breakwater Marina | Queensland | Australia",
    "Townsville | Queensland | Australia",
    "Half Moon Bay Marina | Queensland | Australia",
    "Yorkeys Knob | Queensland | Australia",
    "Queensland | Yorkeys Knob | Queensland | Australia",
    "Port Douglas Marina | Queensland | Australia",
    "Port Douglas | Queensland | Australia",
    "Queensland | Port Douglas | Queensland | Australia",
    "Gulf Point Marina | South Australia | Australia",
    "North Haven | South Australia | Australia",
    "South Australia | North Haven | South Australia | Australia",
    "Holdfast Shores Marina | South Australia | Australia",
    "Glenelg | South Australia | Australia",
    "South Australia | Glenelg | South Australia | Australia",
    "Copper Cove Marina | South Australia | Australia",
    "Wallaroo | South Australia | Australia",
    "South Australia | Wallaroo | South Australia | Australia",
    "Lake Butler Marina | South Australia | Australia",
    "Robe | South Australia | Australia",
    "South Australia | Robe | South Australia | Australia",
    "Port Lincoln | South Australia | Australia",
    "South Australia | Port Lincoln Marina | South Australia | Australia",
    "Tumby Bay | South Australia | Australia",
    "South Australia | Tumby Bay Marina | South Australia | Australia",
    "Melbourne | Victoria | Australia",
    "VicUrban Marina | Victoria | Australia",
    "New Quay | Victoria | Australia",
    "Melbourne Docklands | Victoria | Australia",
    "Waterfront City Marina | Victoria | Australia",
    "Melbourne Docklands | Victoria | Australia",
    "St Kilda Marina | Victoria | Australia",
    "St Kilda | Victoria | Australia",
    "Victoria | Victoria | Australia",
    "Sandringham Yacht Club Marina | Victoria | Australia",
    "Sandringham | Victoria | Australia",
    "Victoria | Victoria | Australia",
    "Brighton Yacht Club Marina | Victoria | Australia",
    "Brighton | Victoria | Australia",
    "Victoria | Victoria | Australia",
    "Blairgowrie Yacht Squadron Marina | Victoria | Australia",
    "Blairgowrie | Victoria | Australia",
    "Victoria | Victoria | Australia",
    "Anchorage Marina | Victoria | Australia",
    "Williamstown | Victoria | Australia",
    "Victoria | Williamstown | Victoria | Australia",
    "Williamstown Yacht Club Marina | Victoria | Australia",
    "Williamstown | Victoria | Australia",
    "Victoria | Williamstown | Victoria | Australia",
    "Whalers Cove Marina | Victoria | Australia",
    "Port Fairy Marina | Victoria | Australia",
    "Bay City Marina | Victoria | Australia",
    "Geelong | Victoria | Australia",
    "Western Port Marina | Victoria | Australia",
    "Hastings | Victoria | Australia",
    "Victoria | Hastings | Victoria | Australia",
    "Western Port Bay | Victoria | Australia",
    "Yaringa Boat Harbour Marina | Victoria | Australia",
    "Sommerville | Victoria | Australia",
    "Western Port Bay | Victoria | Australia",
    "Port of Sale Marina | Victoria | Australia",
    "Sale | Victoria | Australia",
    "Victoria | Sale | Victoria | Australia",
    "Loch Sport Marina | Victoria | Australia",
    "Loch Sport | Victoria | Australia",
    "Victoria | Loch Sport | Victoria | Australia",
    "Mindarie Keys | Western Australia | Australia",
    "Mindarie | Western Australia | Australia",
    "Western Australia | Mindarie | Western Australia | Australia",
    "Hillarys Boat Harbour | Western Australia | Australia",
    "Hillarys | Western Australia | Australia",
    "Western Australia | Hillarys | Western Australia | Australia",
    "Port Bouvard Marina | Western Australia | Australia",
    "Wannanup | Western Australia | Australia",
    "Two Rocks Marina | Western Australia | Australia",
    "Two Rocks | Western Australia | Australia",
    "Western Australia | Two Rocks | Western Australia | Australia",
    "Batavia Coast Marina | Western Australia | Australia",
    "Geraldton | Western Australia | Australia",
    "Western Australia | Geraldton | Western Australia | Australia",
    "Port Geographe Marina | Western Australia | Australia",
    "Geographe | Western Australia | Australia",
    "Western Australia | Geographe | Western Australia | Australia",
    "Darwin | Northern Territory | Australia",
    "Northern Territory | Darwin | Northern Territory | Australia",
    "Tipperary Waters Marina | Northern Territory | Australia",
    "Port Saint Charles | Saint Peter | Barbados",
    "Six Men's Bay | Saint Peter | Barbados",
    "Barbados | Six Men's Bay | Saint Peter | Barbados",
    "Marina Oceania | Cambodia",
    "Sihanoukville Autonomous Port | Cambodia",
    "Pender Harbour | British Columbia | Canada",
    "British Columbia | Sunshine Coast of Canada | British Columbia | Canada",
    "Reed Point Marina | British Columbia | Canada",
    "Quadra Island | British Columbia | Canada",
    "British Columbia | Quadra Island | British Columbia | Canada",
    "Maple Bay Marina | British Columbia | Canada",
    "Maple Bay | British Columbia | Canada",
    "British Columbia | Maple Bay | British Columbia | Canada",
    "Gimli Harbour | Manitoba | Canada",
    "Gimli | Manitoba | Canada",
    "Manitoba | Gimli | Manitoba | Canada",
    "Silver Harbour | Manitoba | Canada",
    "Gimli | Manitoba | Canada",
    "Manitoba | Gimli | Manitoba | Canada",
    "Baddeck Marine (Baddeck)|Baddeck Marine | Nova Scotia | Canada",
    "Baddeck | Nova Scotia | Canada",
    "Nova Scotia | Baddeck | Nova Scotia | Canada",
    "Barra Strait Marina (Grand Narrows) | Nova Scotia | Canada",
    "Grand Narrows | Nova Scotia | Canada",
    "Nova Scotia | Grand Narrows (Barra Strait) | Nova Scotia | Canada",
    "Bras d'Or Yacht Club | Nova Scotia | Canada",
    "Baddeck | Nova Scotia | Canada",
    "Bras d'Or Yacht Club | Nova Scotia | Canada",
    "Baddeck NS – Sailing in Cape Breton Island | website=www.brasdoryachtclub.ca}}</ref> | Nova Scotia | Canada",
    "Cape Breton Boatyard (Baddeck) | Nova Scotia | Canada",
    "Baddeck | Nova Scotia | Canada",
    "Cape Breton Boatyard in Baddeck | Nova Scotia | Canada",
    "NS | Nova Scotia | Canada",
    "Canada - Marina Reviews - Phone Number - Marinas.com | website=marinas.com}}</ref> | Nova Scotia | Canada",
    "St Peter's Lions Club Marina (St. Peter's | Nova Scotia | Canada",
    "Nova Scotia) | St Peter's Lions Club Marina | Nova Scotia | Canada",
    "St. Peter's | Nova Scotia | Canada",
    "Nova Scotia | St. Peter's | Nova Scotia | Canada",
    "Dobson Yacht Club | Nova Scotia | Canada",
    "Westmount | Nova Scotia | Canada",
    "Nova Scotia | Westmount (Sydney) | Nova Scotia | Canada",
    "Northern Yacht Club (North Sydney | Nova Scotia | Canada",
    "Nova Scotia) | Northern Yacht Club | Nova Scotia | Canada",
    "North Sydney | Nova Scotia | Canada",
    "Nova Scotia | North Sydney | Nova Scotia | Canada",
    "Royal Cape Breton Yacht Club (Sydney | Nova Scotia | Canada",
    "Nova Scotia) | Royal Cape Breton Yacht Club | Nova Scotia | Canada",
    "Sydney | Nova Scotia | Canada",
    "Nova Scotia | Sydney | Nova Scotia | Canada",
    "Isle Madame Boat Club (Arichat | Nova Scotia | Canada",
    "Nova Scotia) | Isle Madame Boat Club | Nova Scotia | Canada",
    "Arichat | Nova Scotia | Canada",
    "Nova Scotia | Arichat | Nova Scotia | Canada",
    "Port Hawkesbury Marina (Port Hawkesbury | Nova Scotia | Canada",
    "Nova Scotia) | Port Hawkesbury Marina | Nova Scotia | Canada",
    "Port Hawkesbury | Nova Scotia | Canada",
    "Nova Scotia | Port Hawkesbury | Nova Scotia | Canada",
    "Armdale Yacht Club | Nova Scotia | Canada",
    "Northwest Arm | Nova Scotia | Canada",
    "Dartmouth Yacht Club | Nova Scotia | Canada",
    "Wright's Cove | Nova Scotia | Canada",
    "Royal Nova Scotia Yacht Squadron | Nova Scotia | Canada",
    "Northwest Arm | Nova Scotia | Canada",
    "Shearwater Yacht Club | Nova Scotia | Canada",
    "Shearwater | Nova Scotia | Canada",
    "Nova Scotia | Shearwater (Dartmouth) | Nova Scotia | Canada",
    "Chester Yacht Club | Nova Scotia | Canada",
    "Chester | Nova Scotia | Canada",
    "Nova Scotia | Chester | Nova Scotia | Canada",
    "Lunenburg Yacht Club | Nova Scotia | Canada",
    "Lunenburg | Nova Scotia | Canada",
    "Nova Scotia | Lunenburg | Nova Scotia | Canada",
    "Shelburne Harbour Yacht Club and Marina | Nova Scotia | Canada",
    "Shelburne | Nova Scotia | Canada",
    "Nova Scotia | Shelburne | Nova Scotia | Canada",
    "Ballantynes Cove Marina (Ballantynes Cove)|Ballantynes Cove | Nova Scotia | Canada",
    "Ballantynes Cove | Nova Scotia | Canada",
    "Nova Scotia | Ballantynes Cove | Nova Scotia | Canada",
    "Sunrise Shore Marina | Nova Scotia | Canada",
    "(Home of Barrachois Harbour Yacht Club) | Nova Scotia | Canada",
    "Tatamagouche | Nova Scotia | Canada",
    "Starlite Marina | Ontario | Canada",
    "Sturgeon Falls | Ontario | Canada",
    "Ontario | Sturgeon Falls | Ontario | Canada",
    "Windsor Yacht Club | Ontario | Canada",
    "Windsor | Ontario | Canada",
    "Ontario | Windsor | Ontario | Canada",
    "Bay Port Yachting Centre | Ontario | Canada",
    "Midland | Ontario | Canada",
    "Ontario | Midland | Ontario | Canada",
    "Wye Heritage Marina | Ontario | Canada",
    "Midland | Ontario | Canada",
    "Ontario | Midland | Ontario | Canada",
    "Bellevue Marina | Ontario | Canada",
    "Sault Ste. Marie | Ontario | Canada",
    "Ontario | Sault Ste. Marie | Ontario | Canada",
    "Blind River Marina | Ontario | Canada",
    "Blind River | Ontario | Canada",
    "Ontario | Blind River | Ontario | Canada",
    "Hilton Beach Marina | Ontario | Canada",
    "Hilton Beach | Ontario | Canada",
    "Ontario | Hilton Beach (St. Joseph Island (Ontario) | St. Joseph Island) | Ontario | Canada",
    "Roberta Bondar Transient Marina | Ontario | Canada",
    "Sault Ste. Marie | Ontario | Canada",
    "Britannia Yacht Club | Ontario | Canada",
    "Ottawa | Ontario | Canada",
    "Nepean Sailing Club | Ontario | Canada",
    "Ottawa | Ontario | Canada",
    "Collins Bay Marina | Ontario | Canada",
    "Kingston | Ontario | Canada",
    "Ontario | Kingston | Ontario | Canada",
    "Kingston Yacht Club | Ontario | Canada",
    "Kingston | Ontario | Canada",
    "Ontario | Kingston | Ontario | Canada",
    "Portsmouth Harbour Kingston|Portsmouth Harbour | Ontario | Canada",
    "Kingston | Ontario | Canada",
    "Ontario | Kingston | Ontario | Canada",
    "Friday Harbour Resort Marina | Ontario | Canada",
    "Innisfil | Ontario | Canada",
    "Ontario | Ontario | Canada",
    "Gitchee Gumee Marina | Ontario | Canada",
    "Haviland Bay | Ontario | Canada",
    "Ontario | Haviland Bay | Ontario | Canada",
    "Bellevue Marina | Ontario | Canada",
    "Sault Ste. Marie | Ontario | Canada",
    "Ontario | Sault Ste. Marie | Ontario | Canada",
    "Buck's Marina | Ontario | Canada",
    "Wawa | Ontario | Canada",
    "Ontario | Wawa | Ontario | Canada",
    "MacDonald Turkey Point Marina | Ontario | Canada",
    "Turkey Point | Ontario | Canada",
    "Ontario | Turkey Point | Ontario | Canada",
    "Spinut Marina | Croatia",
    "Split (city) | Split | Croatia",
    "ACI Marina Split | Croatia",
    "Split (city) | Split | Croatia",
    "ACI Marina Umag | Croatia",
    "Umag | Croatia",
    "Marina Punat | Croatia",
    "Punat | Croatia",
    "Limassol Marina | Cyprus",
    "Limassol | Cyprus",
    "Aramis Marina & Yacht Club | Las Cabuyas | Dominican Republic",
    "San Pedro de Macorís Province | Las Cabuyas | Dominican Republic",
    "Hurghada Marina Boulevard | Egypt",
    "Hurghada | Egypt",
    "Abu Tig Marina | Egypt",
    "El Gouna | Egypt",
    "Hurghada | Egypt",
    "San Stefano Marina | Egypt",
    "Alexandria | Egypt",
    "Porto Sokhna | Egypt",
    "Sidi Abdel Rahman | Egypt",
    "Rheinsberg | Brandenburg | Germany",
    "190 spots for vessels | Brandenburg | Germany",
    "Marina Lanke | Berlin | Germany",
    "270 | Berlin | Germany",
    "Kressbronn am Bodensee | Baden-Württemberg | Germany",
    "1500 | Baden-Württemberg | Germany",
    "Bernried am Starnberger See|Bernried | Bavaria | Germany",
    "270 | Bavaria | Germany",
    "Wiesbaden | Hessen|Hesse | Germany",
    "Hohe Düne | Mecklenburg-Vorpommern|Mecklenburg & Western Pomerania | Germany",
    "Rostock – Yachthafen Hohe Düne | Mecklenburg-Vorpommern|Mecklenburg & Western Pomerania | Germany",
    "750 | Mecklenburg-Vorpommern|Mecklenburg & Western Pomerania | Germany",
    "Rechlin | Mecklenburg-Vorpommern|Mecklenburg & Western Pomerania | Germany",
    "350 | Mecklenburg-Vorpommern|Mecklenburg & Western Pomerania | Germany",
    "Stralsund | Mecklenburg-Vorpommern|Mecklenburg & Western Pomerania | Germany",
    "300 | Mecklenburg-Vorpommern|Mecklenburg & Western Pomerania | Germany",
    "Warnemünde | Mecklenburg-Vorpommern|Mecklenburg & Western Pomerania | Germany",
    "Wolgast | Mecklenburg-Vorpommern|Mecklenburg & Western Pomerania | Germany",
    "Emden | Niedersachsen|Lower Saxony | Germany",
    "100 | Niedersachsen|Lower Saxony | Germany",
    "Hannover | Niedersachsen|Lower Saxony | Germany",
    "Bergkamen | Nordrhein-Westfalen|Northrhine-Westphalia | Germany",
    "280 | Nordrhein-Westfalen|Northrhine-Westphalia | Germany",
    "Emmerich am Rhein | Nordrhein-Westfalen|Northrhine-Westphalia | Germany",
    "420 | Nordrhein-Westfalen|Northrhine-Westphalia | Germany",
    "Köln-Zündorf | Nordrhein-Westfalen|Northrhine-Westphalia | Germany",
    "Recke (Westfalen) | Nordrhein-Westfalen|Northrhine-Westphalia | Germany",
    "Mittellandkanal | Nordrhein-Westfalen|Northrhine-Westphalia | Germany",
    "Kosel | Schleswig-Holstein | Germany",
    "Germany | Bohnert – Marina Hülsen | Schleswig-Holstein | Germany",
    "68 | Schleswig-Holstein | Germany",
    "Flensburg | Schleswig-Holstein | Germany",
    "Helgoland | Schleswig-Holstein | Germany",
    "Kiel | Schleswig-Holstein | Germany",
    "2200 | Schleswig-Holstein | Germany",
    "Lübeck | Schleswig-Holstein | Germany",
    "210 | Schleswig-Holstein | Germany",
    "Neustadt in Holstein | Schleswig-Holstein | Germany",
    "Timmendorfer Strand | Schleswig-Holstein | Germany",
    "Uetersen | Schleswig-Holstein | Germany",
    "Agios Kosmas Olympic Sailing Centre | Agios Kosmas Marina | Athens|Athens Metropolitan Area | Greece",
    "Hellinikon | Athens|Athens Metropolitan Area | Greece",
    "Attica | Athens|Athens Metropolitan Area | Greece",
    "Athens Marina (formerly Faliro Marina) | Athens|Athens Metropolitan Area | Greece",
    "Phaleron | Athens|Athens Metropolitan Area | Greece",
    "Attica | Athens|Athens Metropolitan Area | Greece",
    "Flisvos Marina | Athens|Athens Metropolitan Area | Greece",
    "Piraeus | Athens|Athens Metropolitan Area | Greece",
    "Attica | Athens|Athens Metropolitan Area | Greece",
    "Vouliagmeni Marina | Athens|Athens Metropolitan Area | Greece",
    "Vouliagmeni | Athens|Athens Metropolitan Area | Greece",
    "Attica | Athens|Athens Metropolitan Area | Greece",
    "Glyfada Marinas (Glyfada Marina A | Athens|Athens Metropolitan Area | Greece",
    "Glyfada Marina B | Athens|Athens Metropolitan Area | Greece",
    "Glyfada Marina C) | Athens|Athens Metropolitan Area | Greece",
    "Glyfada | Athens|Athens Metropolitan Area | Greece",
    "Attica | Athens|Athens Metropolitan Area | Greece",
    "Olympic Marine | Athens|Athens Metropolitan Area | Greece",
    "Lavrio | Athens|Athens Metropolitan Area | Greece",
    "Attica | Athens|Athens Metropolitan Area | Greece",
    "Marina Zea | Athens|Athens Metropolitan Area | Greece",
    "Piraeus | Athens|Athens Metropolitan Area | Greece",
    "Attica | Athens|Athens Metropolitan Area | Greece",
    "Marina Tzitzifies | Athens|Athens Metropolitan Area | Greece",
    "Kallithea | Athens|Athens Metropolitan Area | Greece",
    "Attica | Athens|Athens Metropolitan Area | Greece",
    "Schoinias Marina | Athens|Athens Metropolitan Area | Greece",
    "Schoinias | Athens|Athens Metropolitan Area | Greece",
    "Attica | Athens|Athens Metropolitan Area | Greece",
    "Agios Nikolaos Marina | Crete | Greece",
    "Agios Nikolaos | Crete | Greece",
    "Crete | Agios Nikolaos | Crete | Greece",
    "Crete | Crete | Greece",
    "Herakleion Marina | Crete | Greece",
    "Herakleion | Crete | Greece",
    "Crete | Crete | Greece",
    "Elounda Marina | Crete | Greece",
    "Elounda | Crete | Greece",
    "Greece | Crete | Greece",
    "Rethymnon Marina | Crete | Greece",
    "Rethymnon | Crete | Greece",
    "Crete | Crete | Greece",
    "Souda Marina | Crete | Greece",
    "Souda | Crete | Greece",
    "Crete | Crete | Greece",
    "Tinos Marina | Cyclades | Greece",
    "Tinos | Cyclades | Greece",
    "Lakki Marina | Dodecanese | Greece",
    "Leros | Dodecanese | Greece",
    "Marina of Lefkas | Ionian Islands | Greece",
    "Lefkas | Ionian Islands | Greece",
    "Kalamaria Marina | Macedonia (Greece)|Macedonia | Greece",
    "Kalamaria | Macedonia (Greece)|Macedonia | Greece",
    "Thessaloniki | Macedonia (Greece)|Macedonia | Greece",
    "Nautical Club of Thessaloniki | Macedonia (Greece)|Macedonia | Greece",
    "Kalamaria | Macedonia (Greece)|Macedonia | Greece",
    "Thessaloniki | Macedonia (Greece)|Macedonia | Greece",
    "Sailing Club of Thessaloniki | Macedonia (Greece)|Macedonia | Greece",
    "Thessaloniki | Macedonia (Greece)|Macedonia | Greece",
    "Porto Carras | Macedonia (Greece)|Macedonia | Greece",
    "Chalkidiki | Macedonia (Greece)|Macedonia | Greece",
    "Kalamata Marina | Peloponnese | Greece",
    "Kalamata | Peloponnese | Greece",
    "Carrickfergus Marina | East Coast | Ireland — whole island",
    "Copeland Marina | East Coast | Ireland — whole island",
    "Portaferry Marina | East Coast | Ireland — whole island",
    "Malahide Marina | East Coast | Ireland — whole island",
    "Dublin | East Coast | Ireland — whole island",
    "Howth Yacht Club Marina | East Coast | Ireland — whole island",
    "Dublin | East Coast | Ireland — whole island",
    "Dublin City Moorings | East Coast | Ireland — whole island",
    "Dun Laoghaire Marina | East Coast | Ireland — whole island",
    "Dublin | East Coast | Ireland — whole island",
    "Kilmore Quay | South Coast | Ireland — whole island",
    "Wexford | South Coast | Ireland — whole island",
    "Waterford City Marina | South Coast | Ireland — whole island",
    "Waterford | South Coast | Ireland — whole island",
    "Three Sisters Marina | South Coast | Ireland — whole island",
    "New Ross | South Coast | Ireland — whole island",
    "Wexford  Upriver/Inland | South Coast | Ireland — whole island",
    "Crosshaven Boatyard | South Coast | Ireland — whole island",
    "County Cork | Cork | South Coast | Ireland — whole island",
    "Royal Cork Yacht Club | South Coast | Ireland — whole island",
    "County Cork | Cork | South Coast | Ireland — whole island",
    "Castlepark Marina | South Coast | Ireland — whole island",
    "Kinsale | South Coast | Ireland — whole island",
    "County Cork | Cork | South Coast | Ireland — whole island",
    "East Ferry Marina | South Coast | Ireland — whole island",
    "Great Island | South Coast | Ireland — whole island",
    "County Cork | Cork | South Coast | Ireland — whole island",
    "Kinsale Marina | South Coast | Ireland — whole island",
    "Kinsale | South Coast | Ireland — whole island",
    "County Cork | Cork | South Coast | Ireland — whole island",
    "Cahersiveen Marina | West Coast | Ireland — whole island",
    "Cahersiveen | West Coast | Ireland — whole island",
    "County Kerry | Kerry | West Coast | Ireland — whole island",
    "Lawrence's Cove Marina | West Coast | Ireland — whole island",
    "Bere Island | West Coast | Ireland — whole island",
    "County Cork | Cork | West Coast | Ireland — whole island",
    "Dingle Marina | West Coast | Ireland — whole island",
    "Dingle | West Coast | Ireland — whole island",
    "County Kerry | Kerry | West Coast | Ireland — whole island",
    "Kilrush Marina | West Coast | Ireland — whole island",
    "Kilrush | West Coast | Ireland — whole island",
    "County Clare | Clare | West Coast | Ireland — whole island",
    "Galway Harbour | West Coast | Ireland — whole island",
    "Galway | West Coast | Ireland — whole island",
    "County Galway | Galway | West Coast | Ireland — whole island",
    "Athlone Marina | River Shannon and inland marinas | Ireland — whole island",
    "Shamrock Marina Esker Banagher | River Shannon and inland marinas | Ireland — whole island",
    "Lough Swilly Marina | North Coast | Ireland — whole island",
    "Glenarm Marina | North Coast | Ireland — whole island",
    "Rathlin Island Marina | North Coast | Ireland — whole island",
    "Seatons Marina | North Coast | Ireland — whole island",
    "Kochi Marina | India",
    "Kochi | India",
    "Nongsa Point Marina | Indonesia",
    "Ashdod Marina|Blue Marina | Mediterranean Sea | Israel",
    "Ashdod | Mediterranean Sea | Israel",
    "Herzliya | Mediterranean Sea | Israel",
    "Haifa | Mediterranean Sea | Israel",
    "Eilat | Red Sea | Israel",
    "Royal Hong Kong Yacht Club | Hong Kong Island | Hong Kong",
    "Causeway Bay (branches at Middle Island & Shelter Cove) | Hong Kong Island | Hong Kong",
    "Aberdeen Boat Club | Hong Kong Island | Hong Kong",
    "Aberdeen Harbour (buoy moorings only | Hong Kong Island | Hong Kong",
    "branch at Middle I) | Hong Kong Island | Hong Kong",
    "Aberdeen Marina Club | Hong Kong Island | Hong Kong",
    "Sham Wan | Hong Kong Island | Hong Kong",
    "Discovery Bay Marina Club | New Territories | Hong Kong",
    "Nim Shue Wan | New Territories | Hong Kong",
    "Discovery Bay | New Territories | Hong Kong",
    "Lantau Island | New Territories | Hong Kong",
    "Club Marina Cove | New Territories | Hong Kong",
    "Ho Chung | New Territories | Hong Kong",
    "Sai Kung district | New Territories | Hong Kong",
    "Hebe Haven Yacht Club | New Territories | Hong Kong",
    "Sai Kung (buoy moorings only) | New Territories | Hong Kong",
    "Gold Coast Yacht & Country Club Marina | New Territories | Hong Kong",
    "Tuen Mun district | New Territories | Hong Kong",
    "Beirut | Lebanon",
    "El Mina | Lebanon",
    "Tripoli | Lebanon",
    "Miri Marina | Malaysia",
    "Perak Marina | Malaysia",
    "Straits Quay | Malaysia",
    "Penang | Malaysia",
    "Tanjung City Marina | Malaysia",
    "Penang | Malaysia",
    "Grand Harbour Marina | Malta",
    "Vittoriosa Marina | Malta",
    "Vittoriosa | Malta",
    "Mġarr Harbour Marina | Malta",
    "Għajnsielem | Malta",
    "Gozo | Malta",
    "Msida Marina | Malta",
    "Msida | Malta",
    "Portomaso|Portomaso Marina | Malta",
    "St Julian's | Malta",
    "Marina Nuevo Vallarta | Mexico",
    "Porto Montenegro | Montenegro",
    "Tivat | Montenegro",
    "Zeewolde | Netherlands",
    "Opua Marina | Opua | New Zealand",
    "Bay of Islands | Opua | New Zealand",
    "Whangarei Marina | Whangarei | New Zealand",
    "Bayswater Marina | Auckland | New Zealand",
    "Gulf Harbour Marina | Auckland | New Zealand",
    "Hobsonville Marina | Auckland | New Zealand",
    "Westhaven Marina | Auckland | New Zealand",
    "biggest marina of the Southern Hemisphere | Auckland | New Zealand",
    "Whitianga Marina | Whitianga | New Zealand",
    "Coromandel | Whitianga | New Zealand",
    "Harbour Bridge Marina | Tauranga | New Zealand",
    "Gisborne Tatapouri Sports Fishing Club | Gisborne | New Zealand",
    "Napier Sailing Club Inc. | Napier | New Zealand",
    "Chaffers Marina | Port Nicholson, Wellington | New Zealand",
    "Wellington City | Port Nicholson, Wellington | New Zealand",
    "Seaview Marina | Port Nicholson, Wellington | New Zealand",
    "Lower Hutt | Port Nicholson, Wellington | New Zealand",
    "Mana Marina | Mana | New Zealand",
    "Paremata | Mana | New Zealand",
    "Wellington | Mana | New Zealand",
    "Havelock Marina | Marlborough Sounds | New Zealand",
    "Havelock | Marlborough Sounds | New Zealand",
    "Waikawa Bay Marina | Marlborough Sounds | New Zealand",
    "nr Picton | Marlborough Sounds | New Zealand",
    "Nelson Marina | Nelson | New Zealand",
    "Try Lyttelton Port | Lyttelton Harbour (for Christchurch) | New Zealand",
    "Otago Yacht Club | Dunedin | New Zealand",
    "Abanico Yacht Club Puerto Princesa | Philippines",
    "Busuanga Yacht Club Coron | Philippines",
    "Palawan | Philippines",
    "Davao Boat and Leisure Club | Philippines",
    "Manila Yacht Club | Philippines",
    "Maya Maya Yacht Club Nasugbu | Philippines",
    "Batangas | Philippines",
    "Punta Fuego Yacht Club | Philippines",
    "Santa Ana Yacht Club Santa Ana | Philippines",
    "Cagayan | Philippines",
    "Taal Lake Yacht Club | Philippines",
    "Gdynia | Poland",
    "Hel | Poland",
    "Poland | Hel | Poland",
    "Puck | Poland",
    "Poland | Puck | Poland",
    "Trzebież | Poland",
    "Wrocław | Poland",
    "Azores | Portugal",
    "Angra do Heroísmo (Terceira Island) | Portugal",
    "Horta (Azores) | Horta (Faial Island) – 4th most visited marina in the world | Portugal",
    "Praia (Azores) | Praia (Graciosa Island) | Portugal",
    "Velas (São Jorge Island) | Portugal",
    "Vila do Porto (Santa Maria Island) | Portugal",
    "Cascais – Cascais Marina | Portugal",
    "Lisboa – Marina Parque das Nações Portugal | Portugal",
    "Vilamoura – Marina de Vilamoura | Portugal",
    "Limanu | Romania",
    "Marina at Keppel Bay | Singapore",
    "Marina Izola | Slovenia",
    "Marina Portorož | Slovenia",
    "Empuriabrava | Spain",
    "Ocean Marina Yacht Club | Thailand",
    " Chonburi Province | Pattaya | Thailand",
    "Phuket Boat Lagoon | Thailand",
    "Phuket Marina | Thailand",
    "Phuket Property | Thailand",
    "Phuket Restaurant | Phuket Province | Phuket | Thailand",
    "Antalya Province | Turkey and Northern Cyprus",
    "Setur Antalya Marina | Turkey and Northern Cyprus",
    "Antalya | Turkey and Northern Cyprus",
    "Park Kemer Marina | Turkey and Northern Cyprus",
    "Kemer | Turkey and Northern Cyprus",
    "D-Marin Didim | Turkey and Northern Cyprus",
    "Didim | Turkey and Northern Cyprus",
    "Setur Kuşadası Marina | Turkey and Northern Cyprus",
    "Kuşadası | Turkey and Northern Cyprus",
    "Setur Ayvalık Marina | Turkey and Northern Cyprus",
    "Ayvalık | Turkey and Northern Cyprus",
    "Ataköy Marina | Turkey and Northern Cyprus",
    "Ataköy | Turkey and Northern Cyprus",
    "Istanbul | Ataköy – Bakırköy (Istanbul | Turkey and Northern Cyprus",
    "European part) | Turkey and Northern Cyprus",
    "Setur Kalamış & Fenerbahçe Marina | Turkey and Northern Cyprus",
    "Kalamış and Fenerbahçe (two adjacent marinas) – Kadıköy (Istanbul | Turkey and Northern Cyprus",
    "Asian part) | Turkey and Northern Cyprus",
    "Viaport Marina | Turkey and Northern Cyprus",
    "Tuzla | Turkey and Northern Cyprus",
    "Istanbul | Tuzla – Tuzla (Istanbul | Turkey and Northern Cyprus",
    "Asian part) | Turkey and Northern Cyprus",
    "Alaçatı Marina | Turkey and Northern Cyprus",
    "Alaçatı | Turkey and Northern Cyprus",
    "Çeşme | Turkey and Northern Cyprus",
    "Setur Çeşme Altınyunus Marina | Turkey and Northern Cyprus",
    "Çeşme | Turkey and Northern Cyprus",
    "Levent İzmir Marina | Turkey and Northern Cyprus",
    "İnciraltı | Turkey and Northern Cyprus",
    "İzmir | Turkey and Northern Cyprus",
    "Palmarina Bodrum | Turkey and Northern Cyprus",
    "Yalıkavak – Bodrum | Turkey and Northern Cyprus",
    "Club Marina | Turkey and Northern Cyprus",
    "Göcek | Turkey and Northern Cyprus",
    "Fethiye | Göcek – Fethiye | Turkey and Northern Cyprus",
    "Port Göcek | Turkey and Northern Cyprus",
    "Göcek | Turkey and Northern Cyprus",
    "Fethiye | Göcek – Fethiye | Turkey and Northern Cyprus",
    "Milta Bodrum Marina | Turkey and Northern Cyprus",
    "Bodrum | Turkey and Northern Cyprus",
    "Port Bodrum Yalıkavak | Turkey and Northern Cyprus",
    "Yalıkavak – Bodrum | Turkey and Northern Cyprus",
    "Port Atami | Turkey and Northern Cyprus",
    "Göltürkbükü – Bodrum | Turkey and Northern Cyprus",
    "D-Marin Turgutreis | Turkey and Northern Cyprus",
    "Turgutreis – Bodrum | Turkey and Northern Cyprus",
    "Marmaris Yatmarin | Turkey and Northern Cyprus",
    "Marmaris | Turkey and Northern Cyprus",
    "Albatros Marina | Turkey and Northern Cyprus",
    "Marmaris | Turkey and Northern Cyprus",
    "Northern Cyprus | Turkey and Northern Cyprus",
    "Girne Marina | Turkey and Northern Cyprus",
    "Girne (Kyrenia) | Turkey and Northern Cyprus",
    "Delta Marina | Turkey and Northern Cyprus",
    "Gazimağusa (Famagusta) | Turkey and Northern Cyprus",
    "Dubai Marina | Dubai | United Arab Emirates",
    "Gallions Point Marina | London | United Kingdom",
    "South Dock | London | United Kingdom",
    "Rotherhithe | South Dock Marina | London | United Kingdom",
    "Poplar Dock|West India Docks Marina | London | United Kingdom",
    "Bourne End Marina | London | United Kingdom",
    "Eyot House Marina | London | United Kingdom",
    "Penton Hook Marina | London | United Kingdom",
    "Shepperton Marina | London | United Kingdom",
    "Thames Ditton Marina | London | United Kingdom",
    "Walton Marina | London | United Kingdom",
    "Leigh Marina | London | United Kingdom",
    "Chatham Maritime Marina | London | United Kingdom",
    "Hoo Marina | London | United Kingdom",
    "Port Medway Marina | London | United Kingdom",
    "Hampstead Marina | London | United Kingdom",
    "Fords Wharf Boatyard | London | United Kingdom",
    "Apsley | Inland | United Kingdom",
    "Hertfordshire | Apsley Marina | Inland | United Kingdom",
    "Grand Union Canal | Inland | United Kingdom",
    "Cow Roast|Cowroast | Inland | United Kingdom",
    "Grand Union Canal | Inland | United Kingdom",
    "Bredon Marina | Inland | United Kingdom",
    "River Avon | Inland | United Kingdom",
    "Warwickshire | River Avon | Inland | United Kingdom",
    "Royal Quays Marina | Inland | United Kingdom",
    "River Tyne | Inland | United Kingdom",
    "Bristol Harbour Marina | South West England | United Kingdom",
    "Falmouth Marina | South West England | United Kingdom",
    "Yacht Haven Quay Plymouth | South West England | United Kingdom",
    "Dry Stack Marina | South West England | United Kingdom",
    "Weymouth and Portland National Sailing Academy|Portland Marina | South West England | United Kingdom",
    "Watchet|Watchet Harbour Marina | South West England | United Kingdom",
    "The Waterfront Barrow-in-Furness|Barrow Marina | Northern England | United Kingdom",
    "Barrow-in-Furness | Northern England | United Kingdom",
    "Hartlepool Marina | Northern England | United Kingdom",
    "Hartlepool | Northern England | United Kingdom",
    "Liverpool Marina | Northern England | United Kingdom",
    "Liverpool | Northern England | United Kingdom",
    "Sunderland Marina | Northern England | United Kingdom",
    "Sunderland | Northern England | United Kingdom",
    "Tyne and Wear | Sunderland | Northern England | United Kingdom",
    "Cardiff Marina | Wales | United Kingdom",
    "Cardiff | Wales | United Kingdom",
    "Aberystwyth Marina | Wales | United Kingdom",
    "Aberystwyth | Wales | United Kingdom",
    "Conwyn Marina | Wales | United Kingdom",
    "Conwy | Wales | United Kingdom",
    "Hafan Pwllheli | Wales | United Kingdom",
    "Pwllheli | Wales | United Kingdom",
    "Holyhead Marina | Wales | United Kingdom",
    "Holyhead | Wales | United Kingdom",
    "Lawrenny Quay Hotel & Yacht Station | Wales | United Kingdom",
    "Kilgetty | Wales | United Kingdom",
    "Fishguard & Goodwick Marina | Wales | United Kingdom",
    "Fishguard (proposed) | Wales | United Kingdom",
    "Neyland Yacht Haven | Wales | United Kingdom",
    "Neyland | Wales | United Kingdom",
    "Penarth Marina | Wales | United Kingdom",
    "Vale of Glamorgan | Wales | United Kingdom",
    "Swansea Marina | Wales | United Kingdom",
    "Swansea | Wales | United Kingdom",
    "Marina Diamandis | Wales | United Kingdom",
    "Brynmawr | Wales | United Kingdom",
    "Belfast Lough | Northern Ireland | United Kingdom",
    "Belfast Marina | Northern Ireland | United Kingdom",
    "Ardglass Marina | Northern Ireland | United Kingdom",
    "Ardglass | Northern Ireland | United Kingdom",
    "Portaferry Marina | Northern Ireland | United Kingdom",
    "Strangford Lough | Northern Ireland | United Kingdom",
    "Troon Yacht Haven | Scotland | United Kingdom",
    "Ayrshire | Scotland | United Kingdom",
    "Kip Marina | Scotland | United Kingdom",
    "River Clyde | Clyde | Scotland | United Kingdom",
    "Ardfern Marina | Scotland | United Kingdom",
    "Loch Craignish | Scotland | United Kingdom",
    "Holy Loch Marina | Scotland | United Kingdom",
    "Sandbank | Scotland | United Kingdom",
    "Argyll and Bute | Scotland | United Kingdom",
    "by Dunoon | Scotland | United Kingdom",
    "Port Edgar Marina | Scotland | United Kingdom",
    "Firth of Forth | Scotland | United Kingdom",
    "Ardrossan Marina | Scotland | United Kingdom",
    "River Clyde | Clyde | Scotland | United Kingdom",
    "Portavadie | Scotland | United Kingdom",
    "Loch Fyne | Scotland | United Kingdom",
    "St. Helier Marina | Channel Islands | United Kingdom",
    "Jersey | Channel Islands | United Kingdom",
    "La Collette Marina | Channel Islands | United Kingdom",
    "Jersey | Channel Islands | United Kingdom",
    "Beaucette Marina | Channel Islands | United Kingdom",
    "Guernsey | Channel Islands | United Kingdom",
    "Woodley Island Marina | California | United States of America",
    "Humboldt Bay (United States) | Humboldt Bay | California | United States of America",
    "Eureka | California | United States of America",
    "California | Eureka | California | United States of America",
    "Downtown Shoreline Marina | California | United States of America",
    "Long Beach | California | United States of America",
    "California | Long Beach | California | United States of America",
    "Rainbow Harbor | California | United States of America",
    "Long Beach | California | United States of America",
    "California | Long Beach | California | United States of America",
    "Cerritos Bahia Marina | California | United States of America",
    "Long Beach | California | United States of America",
    "California | Long Beach | California | United States of America",
    "Marina Pacifica Boat Slips | California | United States of America",
    "Long Beach | California | United States of America",
    "California | Long Beach | California | United States of America",
    "Harborlight Landing At West Coast Hotel | California | United States of America",
    "Long Beach | California | United States of America",
    "California | Long Beach | California | United States of America",
    "Bay Club Apartments & Marina | California | United States of America",
    "Marina del Rey | California | United States of America",
    "California | Marina del Rey | California | United States of America",
    "BoatYard Marina | California | United States of America",
    "Marina del Rey | California | United States of America",
    "California | Marina del Rey | California | United States of America",
    "Catalina Yacht Anchorage | California | United States of America",
    "Marina del Rey | California | United States of America",
    "California | Marina del Rey | California | United States of America",
    "Dock 77 | California | United States of America",
    "Marina del Rey | California | United States of America",
    "California | Marina del Rey | California | United States of America",
    "Dolphin Marina | California | United States of America",
    "Marina del Rey | California | United States of America",
    "California | Marina del Rey | California | United States of America",
    "Holiday Harbor Marina | California | United States of America",
    "Marina del Rey | California | United States of America",
    "California | Marina del Rey | California | United States of America",
    "Monterey Marina | California | United States of America",
    "Monterey | California | United States of America",
    "California | Monterey | California | United States of America",
    "Newport Harbor | California | United States of America",
    "Newport Beach | California | United States of America",
    "California | Newport Beach | California | United States of America",
    "Pier 39 Marina | California | United States of America",
    "San Francisco | California | United States of America",
    "California | San Francisco | California | United States of America",
    "Clipper Yacht Harbor | California | United States of America",
    "Sausalito | California | United States of America",
    "California | Sausalito | California | United States of America",
    "Channel Islands Marina | California | United States of America",
    "Ventura County | California | United States of America",
    "California | Ventura County | California | United States of America",
    "Marina Bay | California | United States of America",
    "Richmond | California | United States of America",
    "California | Marina Bay | California | United States of America",
    "Richmond | California | United States of America",
    "California | Richmond | California | United States of America",
    "Westpoint Harbor | California | United States of America",
    "Redwood City | California | United States of America",
    "California | Redwood City | California | United States of America",
    "Shelter Island | California | United States of America",
    "San Diego | Shelter Island Marina | California | United States of America",
    "San Diego | California | United States of America",
    "California | San Diego | California | United States of America",
    "Cedar Island Marina | Connecticut | United States of America",
    "Angler's Marina | Florida | United States of America",
    "Clewiston | Florida | United States of America",
    "Florida | Clewiston | Florida | United States of America",
    "Bayshore Gardens Marina | Florida | United States of America",
    "Bayshore Gardens | Florida | United States of America",
    "Florida | Bayshore Gardens | Florida | United States of America",
    "Bahia Mar Yachting Center | Florida | United States of America",
    "Fort Lauderdale | Florida | United States of America",
    "Florida | Fort Lauderdale | Florida | United States of America",
    "Hall of Fame Marina | Florida | United States of America",
    "Fort Lauderdale | Florida | United States of America",
    "Harbour Towne Marina | Florida | United States of America",
    "Dania Beach | Florida | United States of America",
    "Florida | Dania Beach | Florida | United States of America",
    "Miami Beach Marina | Florida | United States of America",
    "Miami | Florida | United States of America",
    "Florida | Miami | Florida | United States of America",
    "Haulover Beach Park Marina | Florida | United States of America",
    "Miami | Florida | United States of America",
    "Florida | Miami | Florida | United States of America",
    "Loggerhead Club & Marina | Florida | United States of America",
    "Daytona Beach | Florida | United States of America",
    "Florida | Daytona Beach | Florida | United States of America",
    "Loggerhead Club & Marina | Florida | United States of America",
    "St. Pete Beach | Florida | United States of America",
    "Florida | St. Pete Beach | Florida | United States of America",
    "Loggerhead Club & Marina | Florida | United States of America",
    "Vero Beach | Florida | United States of America",
    "Florida | Vero Beach | Florida | United States of America",
    "Loggerhead Club & Marina | Florida | United States of America",
    "Stuart | Florida | United States of America",
    "Florida | Stuart | Florida | United States of America",
    "Loggerhead Club & Marina | Florida | United States of America",
    "Palm Beach Gardens | Florida | United States of America",
    "Florida | Palm Beach Gardens | Florida | United States of America",
    "Loggerhead Club & Marina | Florida | United States of America",
    "Riviera | Florida | United States of America",
    "Florida | Riviera | Florida | United States of America",
    "Loggerhead Club & Marina | Florida | United States of America",
    "Hollywood | Florida | United States of America",
    "Florida | Hollywood | Florida | United States of America",
    "Loggerhead Club & Marina | Florida | United States of America",
    "S. Lantana | Florida | United States of America",
    "Florida | S. Lantana | Florida | United States of America",
    "Loggerhead Club & Marina | Florida | United States of America",
    "South Miami | Florida | United States of America",
    "Florida | South Miami | Florida | United States of America",
    "St Petersburg Municipal Marina | Florida | United States of America",
    "St Petersburg | Florida | United States of America",
    "Florida | St Petersburg | Florida | United States of America",
    "The Tarpon Club Marina | Florida | United States of America",
    " Naples | Florida | United States of America",
    "Florida | Naples | Florida | United States of America",
    "Twin Dolphin Marina | Florida | United States of America",
    "Bradenton | Florida | United States of America",
    "Florida | Bradenton | Florida | United States of America",
    "Florence Marina State Park | Georgia | United States of America",
    "Ludlow-Bromley Yacht Club | Kentucky | United States of America",
    "Ludlow | Kentucky | United States of America",
    "Kentucky | Ludlow | Kentucky | United States of America",
    "City Yacht Basin | Maryland | United States of America",
    "Havre de Grace | Maryland | United States of America",
    "Maryland | Havre de Grace | Maryland | United States of America",
    "Log Pond Marina | Maryland | United States of America",
    "Havre de Grace | Maryland | United States of America",
    "Sunset Harbor Marina | Maryland | United States of America",
    "Essex | Maryland | United States of America",
    "Maryland | Essex | Maryland | United States of America",
    "New Bedford | Massachusetts | United States of America",
    "Massachusetts | Massachusetts | United States of America",
    "Newburyport Marinas (Newburyport | Massachusetts | United States of America",
    "Massachusetts) | Massachusetts | United States of America",
    "Drummond Island Yacht Haven | Michigan | United States of America",
    "Drummond Island | Michigan | United States of America",
    "George Kemp Marina | Michigan | United States of America",
    "Sault Ste. Marie | Michigan | United States of America",
    "Michigan | Sault Ste. Marie | Michigan | United States of America",
    "Duncan Clinch Marina | Michigan | United States of America",
    "Traverse City | Michigan | United States of America",
    "Tri-Centennial State Park | Michigan | United States of America",
    "Detroit (Detroit River) | Michigan | United States of America",
    "Riverview Resort and Marina | Michigan | United States of America",
    "Barbeau | Michigan | United States of America",
    "Lodge of Four Seasons Marina | Missouri | United States of America",
    "Allen's Dock | New Jersey | United States of America",
    "New Gretna | New Jersey | United States of America",
    "New Jersey | New Gretna | New Jersey | United States of America",
    "Fair Lawn Marina | New Jersey | United States of America",
    "Fair Lawn | New Jersey | United States of America",
    "New Jersey | Fair Lawn | New Jersey | United States of America",
    "Frank S. Farley State Marina | New Jersey | United States of America",
    "Atlantic City | New Jersey | United States of America",
    "New Jersey | Atlantic City | New Jersey | United States of America",
    "79th Street Boat Basin | New York | United States of America",
    "New York | New York | United States of America",
    "New York | Manhattan | New York | United States of America",
    "Erie Basin Marina | New York | United States of America",
    "Buffalo | New York | United States of America",
    "New York | Buffalo | New York | United States of America",
    "World's Fair Marina | New York | United States of America",
    "Queens | New York | United States of America",
    "Battery Park Marina | Ohio | United States of America",
    "Pier 39 Marina | Oregon | United States of America",
    "Astoria | Oregon | United States of America",
    "Oregon | Astoria | Oregon | United States of America",
    "Port of Bandon | Oregon | United States of America",
    "Bandon | Oregon | United States of America",
    "Oregon | Bandon | Oregon | United States of America",
    "Port of Brookings Harbor | Oregon | United States of America",
    "Brookings | Oregon | United States of America",
    "Oregon | Brookings | Oregon | United States of America",
    "Cove Palisades Marina | Oregon | United States of America",
    "Port of The Dalles | Oregon | United States of America",
    "The Dalles | Oregon | United States of America",
    "Oregon | The Dalles | Oregon | United States of America",
    "West Lake Resort | Oregon | United States of America",
    "Florence | Oregon | United States of America",
    "Oregon | Florence | Oregon | United States of America",
    "Garibaldi Marina | Oregon | United States of America",
    "Garibaldi | Oregon | United States of America",
    "Oregon | Garibaldi | Oregon | United States of America",
    "Hood River Yacht Club | Oregon | United States of America",
    "Hood River | Oregon | United States of America",
    "Oregon | Hood River | Oregon | United States of America",
    "Columbia Crossings | Oregon | United States of America",
    "Sundance Yacht Marina | Oregon | United States of America",
    "Jetty Fishery Marina | Oregon | United States of America",
    "Rockaway | Oregon | United States of America",
    "Oregon | Rockaway | Oregon | United States of America",
    "Loon Lake Watersports & Marina | Oregon | United States of America",
    "Reedsport | Oregon | United States of America",
    "Oregon | Reedsport | Oregon | United States of America",
    "Seven Points Marina | Pennsylvania | United States of America",
    "Raystown Lake | Pennsylvania | United States of America",
    "near Huntingdon | Pennsylvania | United States of America",
    "Pennsylvania | Huntingdon | Pennsylvania | United States of America",
    "Puerto Del Rey Marina | Puerto Rico | United States of America",
    "Club Náutico de Ponce | Puerto Rico | United States of America",
    "Brewer Cove Haven Marina | Rhode Island | United States of America",
    "Corpus Christi Marina | Texas | United States of America",
    "Corpus Christi | Texas | United States of America",
    "Texas | Corpus Christi | Texas | United States of America",
    "Yacht Haven Grande | Virgin Islands | United States of America",
    "Saint Thomas | Virgin Islands | United States of America",
    "USVI | Virgin Islands | United States of America",
    "Crown Bay Marina | Virgin Islands | United States of America",
    "Saint Thomas | Virgin Islands | United States of America",
    "USVI | Virgin Islands | United States of America",
    "Washington Sailing Marina | Virginia | United States of America",
    "Alexandria | Virginia | United States of America",
    "Virginia | Alexandria | Virginia | United States of America",
    "Crystal Shores | Virginia | United States of America",
    "Bedford County | Virginia | United States of America",
    "Virginia | Bedford County | Virginia | United States of America",
    "Halesford Harbour | Virginia | United States of America",
    "Bedford County | Virginia | United States of America",
    "Virginia | Bedford County | Virginia | United States of America",
    "Arabella's Landing Marina | Washington | United States of America",
    "Cap Sante Marina | Washington | United States of America",
    "Anacortes | Washington | United States of America",
    "Washington | Anacortes | Washington | United States of America",
    "Squalicum Harbor Marina | Washington | United States of America",
    "Bellingham | Washington | United States of America",
    "Washington | Bellingham | Washington | United States of America",
    "Blaine Harbor Marina | Washington | United States of America",
    "Bremerton Marina | Washington | United States of America",
    "Bremerton | Washington | United States of America",
    "Washington | Bremerton | Washington | United States of America",
    "Port of Edmonds | Washington | United States of America",
    "Edmonds | Washington | United States of America",
    "Washington | Edmonds | Washington | United States of America",
    "Everett Bayside Marine | Washington | United States of America",
    "Everett | Washington | United States of America",
    "Washington | Everett | Washington | United States of America",
    "Port of Kalama | Washington | United States of America",
    "Kalama | Washington | United States of America",
    "Washington | Kalama | Washington | United States of America",
    "Twin Bridges Marina | Washington | United States of America",
    "Mount Vernon | Washington | United States of America",
    "Washington | Mount Vernon | Washington | United States of America",
    "Oak Harbor Marina | Washington | United States of America",
    "Oak Harbor | Washington | United States of America",
    "Washington | Oak Harbor | Washington | United States of America",
    "Swantown Marina & Boatworks | Washington | United States of America",
    "Olympia | Washington | United States of America",
    "Washington | Olympia | Washington | United States of America",
    "Port Ludlow Marina | Washington | United States of America",
    "Port Ludlow | Washington | United States of America",
    "Washington | Port Ludlow | Washington | United States of America",
    "Port Orchard Marina | Washington | United States of America",
    "Port Orchard | Washington | United States of America",
    "Washington | Port Orchard | Washington | United States of America",
    "Point Roberts Marina Resort | Washington | United States of America",
    "Port Roberts | Washington | United States of America",
    "Point Roberts | Washington | United States of America",
    "Washington | Point Roberts | Washington | United States of America",
    "Port of Poulsbo | Washington | United States of America",
    "(Roche Harbor Resort & Marina) | Washington | United States of America",
    "Roche | Washington | United States of America",
    "Washington | Roche | Washington | United States of America",
    "Port of Seattle | Washington | United States of America",
    "Harbor Island Marina | Washington | United States of America",
    "Elliott Bay Marina | Washington | United States of America",
    "Salmon Bay Marina and Boat Sales | Washington | United States of America",
    "John Wayne Marina | Washington | United States of America",
    "Sequim | Washington | United States of America",
    "Washington | Sequim | Washington | United States of America",
    "Chinook Landing Marina | Washington | United States of America",
    "Tacoma | Washington | United States of America",
    "Washington | Tacoma | Washington | United States of America",
    "Columbia Island Marina | Washington, D.C. | United States of America",
    "Columbia Island (District of Columbia) | Columbia Island | Washington, D.C. | United States of America",
    "Gangplank Marina | Washington, D.C. | United States of America",
    "Washington Channel | Washington, D.C. | United States of America",
    "Washington | Washington, D.C. | United States of America",
    "D.C. (Southwest) | Washington, D.C. | United States of America",
    "James Creek Marina | Washington, D.C. | United States of America",
    "Anacostia River | Washington, D.C. | United States of America",
    "Washington | Washington, D.C. | United States of America",
    "D.C. (Southwest) | Washington, D.C. | United States of America",
    "Washington Marina | Washington, D.C. | United States of America",
    "Washington Channel | Washington, D.C. | United States of America",
    "Washington | Washington, D.C. | United States of America",
    "D.C. (Southwest) | Washington, D.C. | United States of America",
    "Milwaukee | Wisconsin | United States of America",
    "Wisconsin | Milwaukee | Wisconsin | United States of America"
  ]
};

module.exports = config;
